import { render, staticRenderFns } from "./ProductManagement.vue?vue&type=template&id=bf7f8d50&scoped=true&"
import script from "./ProductManagement.vue?vue&type=script&lang=ts&"
export * from "./ProductManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7f8d50",
  null
  
)

export default component.exports